module.exports = __webpack_public_path__ + "russierenouvelables/img/hydro-map.688baa6b.webp";